import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { serchSelect } from "@/mixins/index";
import { addappMapp, updateappMapp, returnteappMapp } from "@/api/dataAll/appCorrlist";
import { getadvLocation } from "@/api/dataAll/advLocation";
import { allChannel } from "@/api/aymentsdk/getchancllist";
export default {
  name: "addAppMain",
  props: {
    showing: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      dialogFormVisible: false,
      titleName: "",
      id: "",
      form: {
        game: "",
        platform: "",
        pkg: '',
        channel: '',
        advertiser_id: '',
        advChannel: '',
        advLocation: ''
      },
      expand_parameter: {
        ad_channel: "",
        ad_placement: ""
      },
      ex_Val: [],
      gameId: "",
      value1: "",
      value2: []
    }, _defineProperty(_ref, "id", ""), _defineProperty(_ref, "rules", {
      game: [{
        required: true,
        message: "游戏",
        trigger: "blur"
      }],
      email_list: [{
        required: true,
        message: "请使用英文逗号分隔",
        trigger: "change"
      }] // parameter: [{ required: true, message: "参数", trigger: "blur" }],

    }), _defineProperty(_ref, "formLabelWidth", "80px"), _ref;
  },
  created: function created() {
    var _this = this;

    this.searchMark = {};
    searchgame().then(function (res) {
      _this.searchgames = res.data;
      _this.gameId = res.data.id;
    });
  },
  computed: {
    isShow: {
      get: function get() {
        if (this.showing) {
          return this.showing;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    },
    objArr: {
      get: function get() {
        if (this.obj) {
          return this.obj;
        }
      },
      set: function set(val) {
        this.$emit("changeObj", obj);
      }
    }
  },
  methods: {
    init: function init(item, num) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.dialogFormVisible = true;

                if (num == 1) {
                  _this2.titleName = "新增对用";
                  _this2.form = {};
                } // this.id = id;


                if (num == 2) {
                  _this2.titleName = "修改对用"; // this.id = id;
                  // let tid = {
                  //   id: id,
                  // };
                  // const { data } = await returnteappMapp(tid);

                  _this2.form.game = _this2.objArr.game;
                  _this2.form.platform = _this2.objArr.platform;
                  _this2.form.advertiser_id = _this2.objArr.advertiser_id;
                  _this2.form.channel = _this2.objArr.channel;
                  _this2.form.advChannel = _this2.objArr.ad_channel;
                  _this2.form.advLocation = _this2.objArr.ad_placement;
                  _this2.form.pkg = _this2.objArr.pkg;
                  _this2.form.id = _this2.objArr.id;
                  _this2.searchMark = _objectSpread({}, _this2.objArr);
                  _this2.searchMark.id = _this2.objArr.ID; // this.searchMark.id = this.form.id

                  _this2.$set(_this2.form, _this2.form.game, "");
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    advChannelchange: function advChannelchange(id) {
      var _this3 = this;

      if (id != "") {
        getadvLocation({
          advplatform_id: id
        }).then(function (res) {
          _this3.advLocation = res.data;
          _this3.searchMark.ad_channel = "";

          _this3.advchannels.forEach(function (item) {
            if (item.id == id) {
              _this3.searchMark.ad_channel = item.adv_platform_mark;
              _this3.form.advLocation = "";
              _this3.searchMark.ad_placement = "";
            }
          });
        });
      } else {
        this.form.advLocation = "";
        this.searchMark.ad_placement = "";
        this.searchMark.ad_channel = "";
        this.form.advChannel = "";
        this.advLocation = [];
      }
    },
    advLocationchange: function advLocationchange(id) {
      var _this4 = this;

      if (id != "") {
        this.advLocation.forEach(function (item) {
          if (item.id == id) {
            _this4.searchMark.ad_placement = item.adv_place_mark;
          }
        });
        this.$forceUpdate();
      } else {
        this.searchMark.ad_placement = "";
      }
    },
    textChange: function textChange(val) {
      this.searchMark.advertiser_id = val;
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.$emit("changeShow", false);
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this5 = this;

      if (this.titleName == "新增对用") {
        this.searchMark.kind = 1;
        addappMapp(this.searchMark).then(function (res) {
          if (res.status == 200) {
            Message.success(res.message);

            _this5.$emit("refreshDataList");

            _this5.resetForm("ruleForm");
          } else {
            Message.warning(res.message);

            _this5.resetForm("ruleForm");
          }
        });
      }

      if (this.titleName == "修改对用") {
        updateappMapp(this.searchMark).then(function (res) {
          if (res.status == 200) {
            Message.success(res.message);

            _this5.$emit("refreshDataList");

            _this5.resetForm("ruleForm");
          } else {
            Message.warning(res.message);
          }
        });
      }
    },
    clearData: function clearData() {
      this.form = {};
      this.searchMark = {};
    }
  }
};